import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

import TagManager from 'react-gtm-module';

const tagManagerArgs = [{ gtmId: 'GTM-MHSTDK3' }, { gtmId: 'GTM-NCNHK6' }];

tagManagerArgs.forEach((tm) => TagManager.initialize(tm));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
